/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PaymentSuccessRouteImport } from './routes/payment-success'
import { Route as PaymentsPaymentSuccessRouteImport } from './routes/payments.payment-success'
import { Route as MultibookingsMultibookingGuidIndexRouteImport } from './routes/multibookings.$multibookingGuid.index'
import { Route as CheckoutCheckoutSessionGuidIndexRouteImport } from './routes/checkout.$checkoutSessionGuid.index'
import { Route as BookingsBookingGuidIndexRouteImport } from './routes/bookings.$bookingGuid.index'
import { Route as BookingsBookingGuidSuccessRouteImport } from './routes/bookings.$bookingGuid.success'

const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
  id: '/payment-success',
  path: '/payment-success',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPaymentSuccessRoute = PaymentsPaymentSuccessRouteImport.update({
  id: '/payments/payment-success',
  path: '/payments/payment-success',
  getParentRoute: () => rootRouteImport,
} as any)
const MultibookingsMultibookingGuidIndexRoute =
  MultibookingsMultibookingGuidIndexRouteImport.update({
    id: '/multibookings/$multibookingGuid/',
    path: '/multibookings/$multibookingGuid/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CheckoutCheckoutSessionGuidIndexRoute =
  CheckoutCheckoutSessionGuidIndexRouteImport.update({
    id: '/checkout/$checkoutSessionGuid/',
    path: '/checkout/$checkoutSessionGuid/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingsBookingGuidIndexRoute =
  BookingsBookingGuidIndexRouteImport.update({
    id: '/bookings/$bookingGuid/',
    path: '/bookings/$bookingGuid/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingsBookingGuidSuccessRoute =
  BookingsBookingGuidSuccessRouteImport.update({
    id: '/bookings/$bookingGuid/success',
    path: '/bookings/$bookingGuid/success',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/payment-success': typeof PaymentSuccessRoute
  '/payments/payment-success': typeof PaymentsPaymentSuccessRoute
  '/bookings/$bookingGuid/success': typeof BookingsBookingGuidSuccessRoute
  '/bookings/$bookingGuid': typeof BookingsBookingGuidIndexRoute
  '/checkout/$checkoutSessionGuid': typeof CheckoutCheckoutSessionGuidIndexRoute
  '/multibookings/$multibookingGuid': typeof MultibookingsMultibookingGuidIndexRoute
}
export interface FileRoutesByTo {
  '/payment-success': typeof PaymentSuccessRoute
  '/payments/payment-success': typeof PaymentsPaymentSuccessRoute
  '/bookings/$bookingGuid/success': typeof BookingsBookingGuidSuccessRoute
  '/bookings/$bookingGuid': typeof BookingsBookingGuidIndexRoute
  '/checkout/$checkoutSessionGuid': typeof CheckoutCheckoutSessionGuidIndexRoute
  '/multibookings/$multibookingGuid': typeof MultibookingsMultibookingGuidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/payment-success': typeof PaymentSuccessRoute
  '/payments/payment-success': typeof PaymentsPaymentSuccessRoute
  '/bookings/$bookingGuid/success': typeof BookingsBookingGuidSuccessRoute
  '/bookings/$bookingGuid/': typeof BookingsBookingGuidIndexRoute
  '/checkout/$checkoutSessionGuid/': typeof CheckoutCheckoutSessionGuidIndexRoute
  '/multibookings/$multibookingGuid/': typeof MultibookingsMultibookingGuidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/payment-success'
    | '/payments/payment-success'
    | '/bookings/$bookingGuid/success'
    | '/bookings/$bookingGuid'
    | '/checkout/$checkoutSessionGuid'
    | '/multibookings/$multibookingGuid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/payment-success'
    | '/payments/payment-success'
    | '/bookings/$bookingGuid/success'
    | '/bookings/$bookingGuid'
    | '/checkout/$checkoutSessionGuid'
    | '/multibookings/$multibookingGuid'
  id:
    | '__root__'
    | '/payment-success'
    | '/payments/payment-success'
    | '/bookings/$bookingGuid/success'
    | '/bookings/$bookingGuid/'
    | '/checkout/$checkoutSessionGuid/'
    | '/multibookings/$multibookingGuid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PaymentSuccessRoute: typeof PaymentSuccessRoute
  PaymentsPaymentSuccessRoute: typeof PaymentsPaymentSuccessRoute
  BookingsBookingGuidSuccessRoute: typeof BookingsBookingGuidSuccessRoute
  BookingsBookingGuidIndexRoute: typeof BookingsBookingGuidIndexRoute
  CheckoutCheckoutSessionGuidIndexRoute: typeof CheckoutCheckoutSessionGuidIndexRoute
  MultibookingsMultibookingGuidIndexRoute: typeof MultibookingsMultibookingGuidIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/payment-success': {
      id: '/payment-success'
      path: '/payment-success'
      fullPath: '/payment-success'
      preLoaderRoute: typeof PaymentSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payment-success': {
      id: '/payments/payment-success'
      path: '/payments/payment-success'
      fullPath: '/payments/payment-success'
      preLoaderRoute: typeof PaymentsPaymentSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/multibookings/$multibookingGuid/': {
      id: '/multibookings/$multibookingGuid/'
      path: '/multibookings/$multibookingGuid'
      fullPath: '/multibookings/$multibookingGuid'
      preLoaderRoute: typeof MultibookingsMultibookingGuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/$checkoutSessionGuid/': {
      id: '/checkout/$checkoutSessionGuid/'
      path: '/checkout/$checkoutSessionGuid'
      fullPath: '/checkout/$checkoutSessionGuid'
      preLoaderRoute: typeof CheckoutCheckoutSessionGuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/$bookingGuid/': {
      id: '/bookings/$bookingGuid/'
      path: '/bookings/$bookingGuid'
      fullPath: '/bookings/$bookingGuid'
      preLoaderRoute: typeof BookingsBookingGuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/$bookingGuid/success': {
      id: '/bookings/$bookingGuid/success'
      path: '/bookings/$bookingGuid/success'
      fullPath: '/bookings/$bookingGuid/success'
      preLoaderRoute: typeof BookingsBookingGuidSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  PaymentSuccessRoute: PaymentSuccessRoute,
  PaymentsPaymentSuccessRoute: PaymentsPaymentSuccessRoute,
  BookingsBookingGuidSuccessRoute: BookingsBookingGuidSuccessRoute,
  BookingsBookingGuidIndexRoute: BookingsBookingGuidIndexRoute,
  CheckoutCheckoutSessionGuidIndexRoute: CheckoutCheckoutSessionGuidIndexRoute,
  MultibookingsMultibookingGuidIndexRoute:
    MultibookingsMultibookingGuidIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
